import Lang from '@/modules/core/app/services/Lang';
import { FormSelectConfig } from '@/modules/core/form/models/FormSelectConfig';
import { NotaryStatus } from '@/modules/notary/enums/NotaryStatus';

export class WorkflowNotaryStatusFormSelectConfig extends FormSelectConfig {
  constructor(config: Params = {}) {
    super({
      placeholder: Lang.t('core.select'),
      ...config
    });
  }

  async getOptions(): Promise<NotaryStatus[]> {
    return NotaryStatus.getValues();
  }
}
